import MainApp from "./App.tsx";

export default MainApp;
